import { render, staticRenderFns } from "./Television.vue?vue&type=template&id=844ded7e&lang=pug&"
import script from "./Television.vue?vue&type=script&lang=js&"
export * from "./Television.vue?vue&type=script&lang=js&"
import style0 from "./Television.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Television.vue?vue&type=style&index=1&theme=ffc&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports